'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCATION_REPLACE = exports.LOCATION_GO = exports.LOCATION_CHANGE = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.routerReducer = routerReducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
var LOCATION_GO = exports.LOCATION_GO = '@@router/LOCATION_GO';
var LOCATION_REPLACE = exports.LOCATION_REPLACE = '@@router/LOCATION_REPLACE';

var initialState = {
  location: null
};

function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE || type === LOCATION_REPLACE) {
    return (0, _extends3['default'])({}, state, payload);
  }

  return state;
}


//////////////////
// WEBPACK FOOTER
// ./program/frontend/components/react-router-redux/reducer.js
// module id = 774
// module chunks = 0